module.exports={render:function (){var _vm=this;
  return _vm._c('div', {
    staticClass: "video-player"
  }, [_vm._c('video', {
    staticClass: "video-js vjs-custom-skin",
    class: {
      'live': _vm.options.live
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4280314a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-video-player/player.vue
// module id = 350
// module chunks = 2